import * as React from "react";
import * as PropTypes from "prop-types";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";

import * as Theme from "../../../../app/Theme";

import TSlideDrawer from "../../../common/TSlideDrawer";

import * as gbu from "../../../GB/GBUtil";

import PIContinuationCalcForm from "../../Forms/Reference/PIContinuationCalcForm";
import * as pias from "../../NonComponents/PIAppState";
import * as pip from "../../NonComponents/PIProps";
//import * as pic from "../../NonComponents/PIConst";
import * as php from "../../NonComponents/PIHelp";
import THelpButton from "../../../common/THelpButton";

class PIContinuationCalcSlideDrawer extends React.Component {
  static propTypes = {
    [pias.helpAreaStr]: PropTypes.string,
    [pias.onHelp]: PropTypes.func,

    [pip.onToggleCalcSlideDrawer]: PropTypes.func,
  };

  static defaultProps = {
    [pias.helpAreaStr]: php.config_Cont_CalcRD_HP,
    [pias.onHelp]: () => console.log(pias.onHelp),

    [pip.onToggleCalcSlideDrawer]: () => console.log(pip.onToggleCalcSlideDrawer),
  };

  //==================================================================================================================
  //
  //                                        Life Cycle Events
  //
  //==================================================================================================================

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return gbu.shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
  }

  //==================================================================================================================
  //
  //                                              Event Handlers
  //
  //==================================================================================================================

  onHelpBtnClick = () => {
    this.props.onHelp();
  };

  //==================================================================================================================
  //
  //                                              Render
  //
  //==================================================================================================================

  render() {
    /* props */

    const props = this.props;
    const onToggleCalcSlideDrawer = props[pip.onToggleCalcSlideDrawer];

    /* state */

    //const state = this.state;

    const continuationCalcFormComp = <PIContinuationCalcForm {...{}} />;

    const slideDrawer = (
      <TSlideDrawer
        anchor={"right"}
        onClose={onToggleCalcSlideDrawer}
        content={continuationCalcFormComp}
        headerTitleStyle={{
          color: Theme.PI_SecondaryColor,
        }}
        saveButton={false}
        title={RS(SC.GB_stContCalculator)}
        width={Theme.slideDrawerLv2Width}
        helpBtn={<THelpButton Theme={Theme} onClick={this.onHelpBtnClick} />}
        level={2}
      />
    );

    return slideDrawer;
  }
}

export default PIContinuationCalcSlideDrawer;
